import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tab-cmd-client',
  templateUrl: './tab-cmd-client.component.html',
  styleUrls: ['./tab-cmd-client.component.scss']
})
export class TabCmdClientComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
